/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190703 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { IdentityServerDaoService } from '../identity-server-dao.service';

// CONSTANTS
const IDENTITY_SERVER_KEY = '_identity_server';

@Injectable()
export class IdentityServerStorageDaoService
  implements IdentityServerDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveIdentitiyServer(identityServer: Object): Promise<void> {
    return this.keyValueStorage.store(IDENTITY_SERVER_KEY, identityServer);
  }

  public getIdentitiyServer(): Promise<any> {
    return this.keyValueStorage.load(IDENTITY_SERVER_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(IDENTITY_SERVER_KEY);
  }
}
